export default "__VITE_ASSET__Cgzhy44S__"